module.exports = function() {
  return new Worker("/" + "coffee-transpiler.6abe87e8.worker.js");
};